import React from "react";
import { AutoSuggest } from "../common/AutoSuggest";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { CheckNull, getStorageData } from "../../utils/Validate";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";
import urls from "../../constants";
import QuoteFormSection from "./QuoteFormSection";
import {
  QuoteField,
  QuoteSelectField,
  QuoteTextAreaField,
} from "./QuoteFormFields";

const halfColumn = "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2";

const CustomerContactSection = ({
  allocatedToData,
  copyStatus,
  country,
  countryList,
  customer,
  customerContact,
  customerData,
  deliveryTerms,
  enquiry,
  enquiryData,
  errors,
  HandleFormChange,
  HandleSelect,
  NoOptionsMessage,
  salesEngineer,
  selectCustRef,
  setCountry,
  setCustomer,
  setEnquiry,
  setErrors,
  setSalesEngineer,
  setValues,
  values,
}) => (
  <QuoteFormSection title="Customer & Contact">
    <div className="row compact-form-row">
      <QuoteSelectField id="quote-enquiry-ref" label="Enquiry Ref" error={errors.distributor}>
        <DropDownComponent
          isDisabled={!values?.id ? false : true}
          placeHolder={values?.distributorId ? PlaceHolder.SELECT_ENQUIRY : PlaceHolder.SHOULD_CHOOSE_FIELD("Enquiry Ref")}
          pageName="jobinhand"
          dpDownName="enquiry"
          stateData={enquiryData}
          controlName="enquiry"
          handleChange={(e) => HandleSelect(e, "enquiry")}
          value={enquiry}
          valueId={values?.enquiryId}
          setState={setEnquiry}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteSelectField id="quote-customer-name" label="Customer Name" required error={errors.customer}>
        <DropDownComponent
          placeHolder={values?.distributorId ? PlaceHolder?.SELECT_CUSTOMER : PlaceHolder?.SHOULD_CHOOSE_FIELD("customer")}
          pageName="jobinhand"
          dpDownName="customer"
          stateData={customerData}
          controlName="customer"
          handleChange={(e) => HandleSelect(e, "customer")}
          value={customer}
          valueId={values?.customerId}
          setState={setCustomer}
          multiSelect={false}
          components={values?.distributorId ? { NoOptionsMessage } : ""}
          refComp={selectCustRef}
          isDisabled={
            values?.id && copyStatus !== "copy"
              ? true
              : CheckNull(values?.enquiryId) != ""
                ? true
                : false
          }
        />
      </QuoteSelectField>

      <QuoteTextAreaField
        id="quote-customer-address"
        label="Customer Address"
        className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2"
        error={errors.customerAddress}
        inputClassName="customer-address-textarea"
        placeholder="Enter your address"
        rows="5"
        name="customerAddress"
        value={values?.customerAddress}
        onChange={HandleFormChange}
      />

      <QuoteField
        id="quote-email-address"
        label="Email Address"
        required
        error={errors.email}
        type="text"
        placeholder="Email address"
        name="emailAddress"
        value={values?.emailAddress}
        onChange={HandleFormChange}
      />

      <QuoteField
        id="quote-phone-number"
        label="Phone Number"
        required
        className={halfColumn}
        error={errors.phone}
      >
        <PhoneNumberComponent
          defaultCountry={country?.code}
          errors={errors}
          setValues={setValues}
          setErrors={setErrors}
          filedName="phone"
          values={values}
          inputId="quote-phone-number"
          name="phone"
        />
      </QuoteField>

      <QuoteSelectField
        id="quote-country"
        label="Country"
        required={deliveryTerms?.countryRequired}
        className={halfColumn}
        error={errors.country}
      >
        <DropDownComponent
          isDisabled={true}
          placeHolder={PlaceHolder.SELECT_COUNTRY}
          pageName="jobinhand"
          dpDownName="country"
          stateData={countryList}
          controlName="country"
          handleChange={(e) => HandleSelect(e, "country")}
          value={country}
          valueId={values?.countryId}
          setState={setCountry}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteField
        id="quote-contact-person"
        label="Contact person"
        required
        error={errors.contactPerson}
      >
        <AutoSuggest
          className="form-control"
          options={customerContact}
          setStateValue={setValues}
          stateValue={values}
          placeholder="Enter name"
          params="contactPerson"
          inputId="quote-contact-person"
          name="contactPerson"
        />
      </QuoteField>

      <QuoteSelectField id="quote-sales-engineer" label="Sales Engineer" required error={errors.salesEngineer}>
        <DropDownComponent
          isDisabled={(values?.customerId && getStorageData()?.roleId === urls?.ADMIN_ROLE_ID) ? false : true}
          placeHolder={values?.customerId ? PlaceHolder?.SELECT_SALES_ENGINEER : PlaceHolder?.MUST_CHOOSE_FIELD("customer", "sales engineer")}
          pageName="jobinhand"
          dpDownName="allocatedTo"
          stateData={allocatedToData}
          controlName="assignedInqEngineer"
          handleChange={(e) => HandleSelect(e, "salesEngineer")}
          value={salesEngineer}
          valueId={values?.salesEngineerId?.toLowerCase()}
          setState={setSalesEngineer}
          multiSelect={false}
        />
      </QuoteSelectField>

      <QuoteTextAreaField
        id="quote-other-conditions"
        label="Other Conditions"
        error={errors.otherConditions}
        className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2"
        inputClassName="other-conditions-texta-area"
        placeholder="Enter your notes here"
        rows="5"
        name="otherConditions"
        onChange={HandleFormChange}
        value={values?.otherConditions}
      />
    </div>
  </QuoteFormSection>
);

export default React.memo(CustomerContactSection);
